import React from 'react';
import { Handle, Position } from 'reactflow';
import { Card, CardContent } from '@/shadcn/components/ui/card';

interface DashedPlaceholderNodeProps {
  data: {
    nodeId: string;
    isVisible: boolean;
  };
}

/**
 * DashedPlaceholderNode - Visual placeholder shown when NodeOptionBar is open
 * Provides visual feedback about where the new node will be inserted
 */
export const DashedPlaceholderNode: React.FC<DashedPlaceholderNodeProps> = ({ data }) => {
  const { isVisible } = data;

  if (!isVisible) {
    return null;
  }

  return (
    <div
      className="relative"
      onClick={(e) => {
        // Prevent click from propagating to canvas which would close the toolbar
        e.stopPropagation();
      }}
      onPointerDown={(e) => {
        // Prevent pointer events from dismissing the toolbar
        e.stopPropagation();
      }}
    >
      {/* Input handle */}
      <Handle
        type="target"
        position={Position.Top}
        isConnectable={false}
        className="w-0 h-0 opacity-0"
      />

      {/* Main placeholder container */}
      <div className="flex flex-col items-start justify-center relative w-[342px] transition-all duration-200">
        {/* Simplified placeholder matching Figma design with your provided styling */}
        <Card
          className="w-[342px] h-8 bg-grey-2 rounded-xl border-dashed border-grey-5 pointer-events-none"
        >
          <CardContent className="flex items-center justify-center h-full p-3">
            <div className="flex items-center gap-2 px-2 py-[5px] w-full">
              <div className="flex-1 font-regular-75-caption font-[number:var(--regular-75-caption-font-weight)] text-grey-6 text-[length:var(--regular-75-caption-font-size)] text-center tracking-[var(--regular-75-caption-letter-spacing)] leading-[var(--regular-75-caption-line-height)] [font-style:var(--regular-75-caption-font-style)]">
                +
              </div>
            </div>
          </CardContent>
        </Card>
      </div>

      {/* Output handle */}
      <Handle
        type="source"
        position={Position.Bottom}
        isConnectable={false}
        className="w-0 h-0 opacity-0"
      />
    </div>
  );
};
